export const previewPage = async (dispatch, action, page) => {
  const blankPage = window.open("", "_blank");

  try {
    await dispatch(action);

    blankPage.location.href = `#/preview/${page}`;
  } catch (e) {
    blankPage.close();
  }
};
